module.exports = __webpack_public_path__ + "img/search.f5d3d5c3.svg";